<template>
    <div class="pages__photo">
        <label for="" class="form-label">{{ label }}</label>
        <div class="change" v-if="image">
            <img :src="getNameOfAvatar(image)" alt="Photo" width="115">
            <a @click="$refs.imageInput.click()" href="javascript:void(0)" class="edit">
                <svg width="16" height="16" class="icon">
                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                </svg>
            </a>
        </div>
        <a v-else
           href="javascript:void(0)"
           @click="$refs.imageInput.click()"
           class="upload"
        >
            <img src="/img/svg/photo.svg" alt="" width="43">
            <span>Upload Photo</span>
            <small>Max 10 MB in .jpg/.png format</small>
        </a>
        <input
            type="file"
            style="display: none"
            @change="onImageSelected"
            ref="imageInput"
            accept="image/*"
        >
    </div>


</template>

<script>

export default {
    name: 'LogoAvatarUploader',
    emits: ['update-image'],
    data() {
        return {
            selectedFile: null,
            image: null,
        }
    },

    props: {
        uploadHandler: {
            type: Function,
            required: true
        },
        label: String,
        logo: String,
    },

    watch: {
        logo: {
            handler: function (newVal) {
                if(newVal) {
                    this.image = this.logo
                }
            },
            immediate: true,
        }
    },


    methods: {
        onImageSelected(event) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    this.selectedFile = file;
                    this.uploadPhoto();
                };
                reader.readAsDataURL(file);
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/demo/companies-1.png";
        },
        async uploadPhoto() {
            if (this.selectedFile) {
                this.$showLoadingMessage()
                let formData = new FormData();
                formData.append('files[]', this.selectedFile);
                try {
                    const response = await this.uploadHandler(formData);
                    this.image = response.data[0].file_path
                    this.$emit('update-image', this.image)
                    this.$showSuccessMessage('The image was updated')
                } catch (e) {
                    console.error(e);
                    this.$showErrorMessage("The image was not uploaded");
                }
            } else {
                this.$showErrorMessage("Please select photo");
            }
        },
    }
}

</script>


<style scoped>

</style>
